// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g6xn","question":"styles_question__1IVeL","inputVisibleButton":"styles_inputVisibleButton__1tjQ8","note":"styles_note__3vXs2"};